import React from 'react'
import {ResultsPager} from '../../../../Components/Grid'
import {OwnResultsRow} from "./OwnResultsRow";
import type {SearchCriteria} from "../../../../types";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";


interface OwnSearchResultsViewProps {
    ownResources: Record<string, any>[];
    ownSearchCriteria: SearchCriteria;
    canManageOwnCatalogItems: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
    handleSetOwnSearchCriteria: (criteria: SearchCriteria) => void;
    totalRecords: number;
    redirect?: (path: string) => void;
}

export const OwnSearchResultsView = ({
                                        ownResources,
                                        ownSearchCriteria,
                                        canManageOwnCatalogItems,
                                        handleAddToQueue,
                                        handleEdit,
                                        handleSetOwnSearchCriteria,
                                        totalRecords,

                                    }: OwnSearchResultsViewProps) => {

    const handleFirstClick = () => {
        let criteria = {...ownSearchCriteria, loadSearchResults: true};
        criteria.First();
        handleSetOwnSearchCriteria(criteria);
    };
    const handlePreviousClick = () => {
        let criteria = {...ownSearchCriteria, loadSearchResults: true};
        criteria.Previous();
        handleSetOwnSearchCriteria(criteria);
    };
    const handleNextClick = () => {
        let criteria = {...ownSearchCriteria, loadSearchResults: true};
        criteria.Next();
        handleSetOwnSearchCriteria(criteria);
    };
    const handleLastClick = () => {
        let criteria = {...ownSearchCriteria, loadSearchResults: true};
        criteria.Last(totalRecords);
        handleSetOwnSearchCriteria(criteria);
    };


    const pager = (isSecondaryPager: boolean) => <ResultsPager
        handleFirstClick={handleFirstClick}
        handlePreviousClick={handlePreviousClick}
        handleNextClick={handleNextClick}
        handleLastClick={handleLastClick}
        isSecondaryPager={isSecondaryPager}
        totalRecords={totalRecords}
        recordsPerPage={ownSearchCriteria.recordsPerPage}
        currentPage={ownSearchCriteria.page}
        disabled={false}
    />;

    const noResults = isArrayNullOrEmpty(ownResources);

return <>
    {pager(false)}
    {
        !noResults &&
        ownResources.map((ownResource: Record<string, any>) => {
            return (
                <OwnResultsRow
                    key={ownResource.id}
                    ownResource={ownResource}
                    canManageOwnCatalogItems={canManageOwnCatalogItems}
                    handleAddToQueue={handleAddToQueue}
                    handleEdit={handleEdit}
                />
            );
        })
    }
    {
        noResults && (
            <div className="text-center" data-testid="no-results-row">
                No results found.
            </div>
        )
    }
    {pager(true)}
</>;
}
